import GuideCollection from 'models/guide_collection';
import createConverter from './lib/create_converter';

export default createConverter(GuideCollection);
